<template>
    <div class="bg-white shadow-lg rounded-lg overflow-hidden">
        <div class="bg-primary text-white p-4">
            <h3 class="text-xl font-semibold">Admin Actions</h3>
        </div>
        <div class="p-6">
            <div class="grid grid-cols-1 sm:grid-cols-1 gap-4">
                <button v-for="action in adminActions" :key="action.label" @click="action.handler"
                    class="bg-primary text-white p-4 rounded-lg hover:bg-primary transition duration-300 text-center font-medium">
                    {{ action.label }}
                </button>
            </div>
        </div>
        <QuestionTemplateModal v-if="showQuestionTemplateModal" :show="showQuestionTemplateModal"
            @close="showQuestionTemplateModal = false" />
        <SurveyTemplateModal v-if="showSurveyTemplateModal" :show="showSurveyTemplateModal"
            @close="closeSurveyTemplateModal" />
        <StudentMessageModal :show="showStudentMessageModal" @close="showStudentMessageModal = false" />
    </div>

</template>

<script>
import QuestionTemplateModal from './modals/QuestionTemplateModal.vue'
import SurveyTemplateModal from './modals/SurveyTemplateModal.vue'
import StudentMessageModal from './modals/StudentMessageModal.vue'
export default {
    name: 'AdminActions',
    components: {
        QuestionTemplateModal,
        SurveyTemplateModal,
        StudentMessageModal
    },
    data() {
        return {
            adminActions: [
                { label: 'Define Survey Template', handler: this.defineSurveyTemplate },
                { label: 'Define Question Template', handler: this.defineQuestionTemplate },
                { label: 'Sync Data from 3rd Party', handler: this.syncData },
                { label: 'Message Settings', handler: this.setStudentMsg },
                { label: 'System Settings', handler: this.systemSettings }
            ],
            showQuestionTemplateModal: false,
            showSurveyTemplateModal: false,
            showStudentMessageModal: false
        }
    },
    methods: {
        setStudentMsg(){
            this.showStudentMessageModal = true
        },
        defineSurveyTemplate() {
            console.log('Define Survey Template')
            this.showSurveyTemplateModal = true
            // Implement survey template definition logic
        },
        defineQuestionTemplate() {
            this.showQuestionTemplateModal = true
        },
        syncData() {
            console.log('Sync Data from 3rd Party')
            // Implement data synchronization logic
        },
        systemSettings() {
            console.log('System Settings')
            // Implement system settings logic
        },
        onTemplateSaved(template) {
            console.log('Question template saved:', template)
            this.showQuestionTemplateBuilder = false
            // Here you would typically handle the saved template, e.g., add it to a list of templates
        },
        openSurveyTemplateModal() {
            this.showSurveyTemplateModal = true
        },
        closeSurveyTemplateModal() {
            this.showSurveyTemplateModal = false
        },
    }
}
</script>